<div class="container">
  <a
    class="btn btn-action btn-small back-navigation"
    [routerLink]="{ cxRoute: 'creditClaims' } | cxUrl"
    [queryParams]="sharedService.getQueryParamsLocal('creditClaims')"
    >
    <i class="fas fa-arrow-left mr-1"></i>
    {{ 'shared.backTo.creditClaims' | cxTranslate }}
  </a>

  @if (creditClaim) {
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-3 card-body--label">
          <b>{{ 'creditClaims.status' | cxTranslate }}</b>
          <span>{{ 'creditClaims.statuses.' + creditClaim?.status | cxTranslate }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-3 card-body--label">
          <b>{{ 'shared.orderNumber' | cxTranslate }}</b>
          <!-- <span>{{ creditClaim?.creditClaimCode }}</span> -->
          <span>{{ creditClaim?.invoiceNumber }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-3 card-body--label">
          <b>{{ 'shared.reason' | cxTranslate }}</b>
          <span>{{ 'creditClaims.reasons.' + creditClaim?.reason | cxTranslate }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-3 card-body--label">
          <!-- <b>{{ 'creditClaims.invoiceNumber' | cxTranslate }}</b>
          <span>{{ creditClaim?.invoiceNumber }}</span> -->
          <b>{{ 'creditClaims.ClaimNumber' | cxTranslate }}</b>
          <span>{{ creditClaim?.ticketId }}</span>
        </div>
        @if (creditClaim?.comments?.length && creditClaim?.comments[0].text?.length) {
          <div
            class="col-12 card-body--label"
            >
            <b>{{ 'shared.comments' | cxTranslate }}</b>
            <span>{{ creditClaim.comments[0].text }}</span>
          </div>
        }
        <div class="col-12 card-body--label2">
          <b>{{ 'shared.essityComment' | cxTranslate }}</b>
          <span>{{ creditClaim.essityComment }}</span>
        </div>
        <div class="col-12 agreement-detail-actions">
          @if (creditClaim?.resolutionDocumentUrl) {
            <button
              class="btn btn-small btn-primary ml-2 mt-2"
              (click)="getResolutionDocumentUrl(creditClaim)"
              >
              {{ 'creditClaims.downloadResolutionDocument' | cxTranslate }}
            </button>
          }
          @if (creditClaim?.images?.length > 0) {
            <button
              type="button"
              class="btn btn-small btn-primary ml-2 mt-2"
              (click)="showAttachments(creditClaim)"
              >
              {{ 'creditClaims.viewAttachments' | cxTranslate }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>

@if (creditClaim?.items?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="productCode"
    [rows]="creditClaim?.items"
  ></app-custom-table>
}

@if (showInitialLoader) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
